import { graphql } from "relay-runtime";

export const topAprQuery = graphql`
  query AutomatedTradingPromoQuery(
    $minInvestmentAgeDays: Int!
    $minValueUsd: Bigint!
  ) {
    finV3 {
      ranges(
        first: 1
        status: OPEN
        sortBy: APR
        sortDir: DESC
        minInvestmentAgeDays: $minInvestmentAgeDays
        minValueUsd: $minValueUsd
      ) {
        edges {
          node {
            analytics {
              apr
            }
          }
        }
      }
    }
  }
`;
